<template>
  <div class="students">
    <el-table class="student_list" :data="studentList">
      <el-table-column prop="avatar" label="头像" width="100" align="center">
        <template slot-scope="scope">
          <el-image
            :src="
              scope.row.avatar || require('@/assets/images/icons/icon_me.png')
            "
            style="width: 44px; height: 44px"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="姓名" width="120" align="center">
      </el-table-column>
      <el-table-column prop="username" label="账号" width="120" align="center">
      </el-table-column>
      <el-table-column prop="sno" label="学号" width="120" align="center">
      </el-table-column>
      <el-table-column
        prop="sex"
        label="性别"
        :formatter="sexFormatter"
        width="100"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="score" label="成绩" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.score ? Number(scope.row.score.toFixed(2)) : 0 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="teamName"
        label="所属团队"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.teamName || "无" }}
        </template>
      </el-table-column>
      <el-table-column prop="postName" label="岗位" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.postName || "无" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="加入日期"
        :formatter="formatter"
        align="center"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { studentList } from "@/api/class";
import { formatDate } from "@/utils/index";
export default {
  data() {
    return {
      studentList: [],
      showAdd: false,
      studentIDs: "",
      showConfirm: false,
      classUserId: null,
    };
  },
  created() {
    this.getStudents();
  },
  methods: {
    // 班级学生
    getStudents() {
      this.$loading.show();
      studentList({
        classId: this.$route.query.id,
      }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.studentList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 格式化时间
    formatter(row) {
      return formatDate(row.updateTime, "YYYY-MM-DD HH:mm:ss");
    },
    // 性别
    sexFormatter(row) {
      if (row.sex == "UNKNOW") {
        return "未知";
      } else if (row.sex == "MAN") {
        return "男";
      } else {
        return "女";
      }
    },
    // 导出
    onExport() {},
  },
};
</script>

<style lang="less" scoped>
.students {
  background-color: rgb(255, 255, 255);

  .top_row {
    margin-bottom: 10px;
    line-height: 40px;
    overflow: hidden;

    .title {
      float: left;
    }

    .btn {
      float: right;
    }
  }

  ::v-deep .student_list {
    .is-leaf {
      color: #fff;
      background-color: teal;
    }
  }
}
</style>
